import { useEffect, useState } from 'react';
import ModalV2 from '../../ModalV2';
import useModal from '../../../hooks/useModal';

const MODAL_NAME = 'translation-import-modal';

export default function ImportTranslationModal() {
  const { close, data } = useModal(MODAL_NAME);
  const [content, setContent] = useState('');

  useEffect(() => {
    if (!data) {
      setContent('');
    }
  }, [data]);

  return (
    <ModalV2 name={MODAL_NAME} title="Import Translations" className="w-full max-w-lg">
      <div className="space-y-4">
        <textarea
          value={content}
          onChange={(e) => setContent(e.target.value)}
          placeholder="Paste JSON or CSV content here"
          className="w-full min-h-[160px] border border-gray-300 rounded-lg p-3 text-sm"
        />

        <div className="flex gap-4">
          <button onClick={close} className="bg-red-300 px-4 py-2 rounded">
            Cancel
          </button>
          <button onClick={close} className="bg-blue-300 px-4 py-2 rounded">
            Confirm
          </button>
        </div>
      </div>
    </ModalV2>
  );
}